import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable, Subject, throwError} from "rxjs";
import {catchError, switchMap } from "rxjs/operators";
import {AuthService} from "../auth/auth.service";
import {RequestService} from "./request.service";


@Injectable({
    providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
    tokenSubject: Subject<boolean> = new Subject<boolean>();

    constructor(private requestService: RequestService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(catchError((err) => this.errorHandler(err, req, next)));
    }

    errorHandler(error: HttpErrorResponse, req: HttpRequest<any>, next: HttpHandler): Observable<any> {
        if (error.status === 403) {
            const authService = new AuthService();
            authService.logout();
            window.location.href = '/auth/login';
            return throwError(error);
        } else if (error.status === 401) {
            return this.handleUnauthorized(req, next);
        } else {
            return throwError(error);
        }
    }

   addToken(request: HttpRequest<any>, token: string): any {
        return request.clone({
          setHeaders: { 'Authorization': `Bearer ${token}` }
        });
   }


    handleUnauthorized(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
        this.tokenSubject.next(undefined);
        // get a new token via userService.refreshToken
        const authService = new AuthService();
        const token: any = authService.getToken();
        return  this.requestService.post('renew', {
            refresh_token: token?.refresh_token
        })
            .pipe(switchMap((newToken: any) => {
                    this.tokenSubject.next(newToken);
                    authService.setToken(newToken);
                    return next.handle(this.addToken(req, newToken.access_token));
                })
            );
    }


}
